define('modules/editor/views/elements/video',['require','exports','module','./element','../../models/editorstate','env','ldsh!../../templates/elements/video_amp','ldsh!../../templates/elements/video_editor_amp','ldsh!../../templates/elements/video'],function (require, exports, module) {
  "use strict";
  var BaseElement = require("./element"),
    EditorState = require("../../models/editorstate"),
    config = require("env");

  module.exports = BaseElement.extend({
    template: null,
    className: "ed-panel-item ed-item-media",

    initialize: function () {
      this.template = this._getVideoTemplate();
      return module.exports.__super__.initialize.apply(this, arguments);
    },

    _getVideoTemplate: function () {
      if (EditorState.getAMPState()) {
        if (EditorState.isGenerateMode()) {
          return require("ldsh!../../templates/elements/video_amp");
        }

        return require("ldsh!../../templates/elements/video_editor_amp");
      }

      return require("ldsh!../../templates/elements/video");
    },

    helpers: function() {
      var templateParams = {
        assetsHost: config.assetsHost
      };

      if (EditorState.getAMPState() && EditorState.isGenerateMode()) {
        templateParams.videoID = this.model.getContent();
      }

        return templateParams;
    },

    onEditContent: function () {
      this.model.editVideoContent();
    }
  });
});

